const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const revealObserver = prefersReducedMotion
  ? null
  : new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
    );

const parallaxElements = new Set();
let parallaxTicking = false;

function handleParallax() {
  parallaxTicking = false;
  parallaxElements.forEach((element) => {
    const strength = Number(element.dataset.parallaxStrength || 0.3);
    const rect = element.getBoundingClientRect();
    const offset = (rect.top - window.innerHeight / 2) * -strength;
    element.style.setProperty('--parallax-shift', `${offset}px`);
  });
}

function requestParallaxFrame() {
  if (parallaxTicking || prefersReducedMotion) return;
  parallaxTicking = true;
  requestAnimationFrame(handleParallax);
}

function initParallax(scope = document) {
  if (prefersReducedMotion) return;
  scope.querySelectorAll('[data-parallax]').forEach((element) => {
    parallaxElements.add(element);
  });
  requestParallaxFrame();
}

function initReveal(scope = document) {
  if (!revealObserver) {
    scope.querySelectorAll('[data-reveal]').forEach((element) => {
      element.classList.add('is-visible');
    });
    return;
  }

  scope.querySelectorAll('[data-reveal]').forEach((element) => {
    revealObserver.observe(element);
  });
}

function toggleFaqItem(item, expanded) {
  const button = item.querySelector('.brite-faq__toggle');
  const panel = item.querySelector('.brite-faq__panel');

  if (!button || !panel) return;

  button.setAttribute('aria-expanded', expanded);
  item.toggleAttribute('open', expanded);

  if (expanded) {
    panel.hidden = false;
    const targetHeight = panel.scrollHeight;
    panel.style.maxHeight = `${targetHeight}px`;
  } else {
    panel.style.maxHeight = '0px';
    window.setTimeout(() => {
      if (!item.hasAttribute('open')) panel.hidden = true;
    }, 300);
  }
}

function initFaq(scope = document) {
  const items = scope.querySelectorAll('[data-faq-item]');
  if (!items.length) return;

  items.forEach((item) => {
    const button = item.querySelector('.brite-faq__toggle');
    const panel = item.querySelector('.brite-faq__panel');

    if (!button || !panel) return;

    const defaultOpen = item.dataset.defaultOpen === 'true';

    if (defaultOpen) {
      toggleFaqItem(item, true);
    }

    button.addEventListener('click', () => {
      const isOpen = item.hasAttribute('open');
      toggleFaqItem(item, !isOpen);
    });
  });
}

function initBriteHomepage(scope = document) {
  initReveal(scope);
  initParallax(scope);
  initFaq(scope);
}

function recalcOpenFaqPanels() {
  document.querySelectorAll('.brite-faq__item[open] .brite-faq__panel').forEach((panel) => {
    panel.style.maxHeight = `${panel.scrollHeight}px`;
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initBriteHomepage();
  window.addEventListener('scroll', requestParallaxFrame, { passive: true });
  window.addEventListener('resize', () => {
    requestParallaxFrame();
    recalcOpenFaqPanels();
  });
});

document.addEventListener('shopify:section:load', (event) => {
  initBriteHomepage(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-parallax]').forEach((element) => {
    parallaxElements.delete(element);
  });
});
